module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP///////////////////////////////////////////////////////////////8/RimEAAAAQdFJOUwAmcGPxkDDg0LqzyZ55AUgkWjC2AAAAX0lEQVQY073O0QqAIAwF0KnbbKnl/39tM4Jo7UEIuo+HcXdBuhOB7maKsaYUV8s5gCZa3sFj3ACYajG86Gl5vxyc5xiZx47A/BiI5wrQr+Lw1XN3EzU9bkQflvzI4rEcWGEX+S7imiMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fb_0609.png
// module id = 1697
// module chunks = 5